import { track } from 'lib/babylistHealthAnalytics'
import { decorateEventPayload } from './decorateEventPayload'

export const physicianResultViewedEvent = (tracker: any) => () => {
  const payload = decorateEventPayload({ event: track.physicianResultViewed })
  tracker.trackEvent(payload)
}
